import { NgModule } from '@angular/core';
import { PageMetaResolver } from '@spartacus/core';
import { ArticlePageMetaResolver } from './resolvers';

@NgModule({
  providers: [
    {
      provide: PageMetaResolver,
      useExisting: ArticlePageMetaResolver,
      multi: true,
    },
  ],
})
export class ArticleFeatureModule {}
